<div class="step-indicator-sm1">
  <c11n-step-indicator [stepAlign]="'start'" [stepLabelDisplay]="'all'" [stepLabels]="stepLabels"
  [currentStep]="currentStep">
</c11n-step-indicator>
</div>
